export class Reward {
  type: string;
  data: any;

  constructor(reward?: Reward) {
    this.type = (reward && reward.type) ? reward.type : '';
    this.data = (reward && reward.data) ? reward.data : {};
  }

}
